import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { render } from 'react-dom';
import Router from 'components/router';
import { BrowserRouter } from 'react-router-dom';
import InternationalizationProvider from 'providers/internationalization';
import languages from 'data/languages.json';
import ls from 'local-storage';
import localeData from 'data/translations.json';
import Promise from 'promise-polyfill';
import Cookies from 'universal-cookie';
import axios from 'axios';
import queryString from 'query-string';
import _compact from 'lodash/compact';
// To add to window
if (!window.Promise) {
  window.Promise = Promise;
}

const cookies = new Cookies();

const callLang = (cookies.get('call-lang')) ? cookies.get('call-lang').substring(0, 2) : null;

const language =
  callLang ||
  ls.get('userLanguage') || // had to leave this here as we deployed with it.
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage;

if (!callLang) {
  cookies.set('call-lang', language, {
    domain: window.location.hostname.substring(window.location.hostname.lastIndexOf(".", window.location.hostname.lastIndexOf(".") - 1) + 1),
    path: '/',
  });
}

const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

const countryCode = (languages[languageWithoutRegionCode]) ? languageWithoutRegionCode : 'en';

const url = new URL(`${process.env.REACT_APP_BASE_URL}/getAuth/`);
const urlSegments = window.location.pathname.split('/');
const lastSegment = urlSegments[urlSegments.length - 1];
if (parseInt(lastSegment, 10)) {
  url.searchParams.set('extension', lastSegment);
}
axios.get(url.href, { withCredentials: true }).then((response) => {
  const data = response && response.data;
  const extension = data.extension ? data.extension : false;

  if (extension && data.redirectToLauncher) {
    const qsIn = queryString.parse(window.location.search);
    const qsOut = _compact([
      `ext=${encodeURIComponent(extension)}`,
      `lang=${encodeURIComponent(countryCode)}`,
      qsIn.source && `source=${encodeURIComponent(qsIn.source)}`
    ]).join('&');
    const currentLocation = window.location.hostname.split('.');
    const currentEnvironment = currentLocation.slice(currentLocation.length - 2).join('.');
    const launcherURL = `https://launch.${currentEnvironment}/`;
    const fullLauncherUrl = `${launcherURL}?${qsOut}`;
    window.location.href = fullLauncherUrl;
  } else if (extension && data.redirectToWebApp) {
    const webappUrl = process.env.REACT_APP_WEBAPP_URL;
    const fullWebAppUrl = `${webappUrl}/join/${encodeURIComponent(extension)}`;
    window.location.href = fullWebAppUrl;
  } else {
    renderApp();
  }
}).catch(() => {
  renderApp();
});

const renderApp = () => {
  const messages = localeData[languageWithoutRegionCode] || localeData[language] || localeData.en;

  render(
    <BrowserRouter>
      <InternationalizationProvider messages={messages} countryCode={countryCode}>
        <Router />
      </InternationalizationProvider>
    </BrowserRouter>,
    document.getElementById('root'),
  );
}

